import { useCallback, useEffect, useState } from "react";

export function useCooldown(initialSeconds = 0) {
	const [seconds, setSeconds] = useState(initialSeconds);
	const active = seconds > 0;

	useEffect(() => {
		if (!active) return;
		const id = setInterval(
			() => setSeconds((s) => Math.max(0, s - 1)),
			1000,
		);
		return () => clearInterval(id);
	}, [active]);

	const start = useCallback((n: number) => {
		setSeconds(Math.max(0, Math.ceil(n)));
	}, []);

	return { seconds, active, start };
}
